import { FREQUENCY_OPTIONS } from '../home.js';

/* The Frequency filter used on Home and Summary: All frequencies / Monthly / Quarterly / Annual. */
export default function FrequencySelect({ id, value, onChange }) {
  return (
    <>
      <label htmlFor={id}>Frequency</label>
      <select id={id} className="ui dropdown" value={value} onChange={(e) => onChange(e.target.value)}>
        {FREQUENCY_OPTIONS.map(([v, label]) => <option key={v || 'all'} value={v}>{label}</option>)}
      </select>
    </>
  );
}
